/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{BlendTechnique as e}from"../shaderGraph/techniques/blend/BlendTechnique.js";class n{constructor(){this._blendTechnique=new e}dispose(e){this._blendTechnique?.shutdown()}draw(e,n,d,i,o){this._blendTechnique.render(e,{colorTexture:n,config:{opacity:o,samplingMode:d},blendMode:i})}}export{n as BlendEffect};
